import { normalizeLanguage } from '@chilipiper/locale/src/new'
import { useMessageFeedContext } from '../../../chat-widget/MessageFeedContext'
import { useTranslationsWithEnglishFallback } from '../../../hooks/useTranslations'
import { FillFormBlock as FillFormBlockType } from '../../../chat-data/types'
import { mapFormFields } from './helpers'

export const useFillFormBlock = (block: FillFormBlockType) => {
  const { tenantId, workspaceId = '' } = useMessageFeedContext()
  const locale = normalizeLanguage(navigator.language)
  const translations = useTranslationsWithEnglishFallback(tenantId, workspaceId, locale)
  return mapFormFields({
    locale,
    translations,
    dataFields: block.fields,
  })
}
